"use client";

import Image from "next/image";
import { useState } from "react";
import styles from "./Avatar.module.css";

type Props = {
  url?: string | null;
  name: string;
  size?: number;
};

export default function Avatar(props: Props) {
  const { url, name, size = 40 } = props;

  const [failedUrl, setFailedUrl] = useState<string | null>(null);

  if (url && failedUrl !== url) {
    return (
      <Image
        src={url}
        alt={name}
        width={size}
        height={size}
        className={styles.image}
        unoptimized={true}
        onError={() => setFailedUrl(url)}
      />
    );
  }

  return (
    <span
      className={styles.fallback}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.4) }}
    >
      {name.trim().charAt(0) || "?"}
    </span>
  );
}
